import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { userType } from 'src/app/shared/enum/userType';

@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.css']
})
export class LoginCardComponent implements OnInit {
  // tslint:disable-next-line:no-output-on-prefix
  @Output('onClick') onClick = new EventEmitter();
  // tslint:disable-next-line:no-input-rename
  @Input('loginType') loginType: userType;
  @Input('iconClass') iconclass: string;
  @Input('btn') btn: string;
  constructor() { }

  ngOnInit(): void {
  }

  showModal(): void {
    this.onClick.emit(this.loginType);
  }
}
